import { ysrLabelColorObjs } from 'src/features/yellStory/constants/colors'
import { StateObj } from 'src/types'

// ベースになる黒地部分
export const labelBase = (ctx: CanvasRenderingContext2D, outOfEdgeColor: string, x: number, y: number): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = outOfEdgeColor
  ctx.beginPath()
  ctx.fillStyle = outOfEdgeColor //'#140C09'
  ctx.moveTo(378 + x, 585 + y) // 左下
  ctx.quadraticCurveTo(396 + x, 563 + y, 398 + x, 563 + y) //
  ctx.quadraticCurveTo(408 + x, 570 + y, 422 + x, 566 + y) //
  ctx.quadraticCurveTo(435 + x, 575 + y, 447 + x, 562 + y) //
  ctx.quadraticCurveTo(464 + x, 573 + y, 472 + x, 565 + y) //
  ctx.quadraticCurveTo(497 + x, 549 + y, 490 + x, 544 + y) //
  ctx.lineTo(504 + x, 534 + y) //
  ctx.quadraticCurveTo(512 + x, 517 + y, 498 + x, 514 + y) //
  ctx.lineTo(461 + x, 517 + y) //
  ctx.quadraticCurveTo(457 + x, 504 + y, 448 + x, 507 + y) //
  ctx.lineTo(426 + x, 511 + y) //
  ctx.quadraticCurveTo(415 + x, 494 + y, 412 + x, 496 + y) //
  ctx.quadraticCurveTo(408 + x, 495 + y, 402 + x, 498 + y) //
  ctx.quadraticCurveTo(379 + x, 504 + y, 356 + x, 518 + y) //
  ctx.quadraticCurveTo(352 + x, 521 + y, 348 + x, 528 + y) //
  ctx.quadraticCurveTo(335 + x, 527 + y, 338 + x, 545 + y) //
  ctx.quadraticCurveTo(342 + x, 555 + y, 349 + x, 564 + y) //
  ctx.quadraticCurveTo(363 + x, 581 + y, 378 + x, 585 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// ラベルのコアとなる部分
export const labelCore = (ctx: CanvasRenderingContext2D, edgeColor: string, coreColor: string, x: number, y: number): void => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = edgeColor
  ctx.beginPath()
  ctx.fillStyle = coreColor
  ctx.moveTo(373 + x, 575 + y) // 左下
  ctx.quadraticCurveTo(397 + x, 548 + y, 399 + x, 550 + y) // 右上
  ctx.quadraticCurveTo(406 + x, 566 + y, 424 + x, 556 + y) //
  ctx.quadraticCurveTo(431 + x, 561 + y, 433 + x, 561 + y) //
  ctx.quadraticCurveTo(438 + x, 560 + y, 446 + x, 550 + y) // 右上
  ctx.quadraticCurveTo(455 + x, 558 + y, 465 + x, 559 + y) //
  ctx.quadraticCurveTo(476 + x, 554 + y, 482 + x, 547 + y) // 右上1
  ctx.quadraticCurveTo(486 + x, 542 + y, 478 + x, 544 + y) // 右上2
  ctx.quadraticCurveTo(461 + x, 549 + y, 461 + x, 549 + y) // 左下1
  ctx.quadraticCurveTo(455 + x, 547 + y, 460 + x, 545 + y) // 左下2
  ctx.quadraticCurveTo(499 + x, 536 + y, 498 + x, 526 + y) // 右上
  ctx.quadraticCurveTo(456 + x, 529 + y, 409 + x, 537 + y) //
  ctx.quadraticCurveTo(450 + x, 521 + y, 450 + x, 523 + y) // 右上1
  ctx.quadraticCurveTo(451 + x, 518 + y, 450 + x, 519 + y) // 右上2
  ctx.quadraticCurveTo(423 + x, 523 + y, 403 + x, 534 + y) //
  ctx.quadraticCurveTo(415 + x, 519 + y, 417 + x, 521 + y) //
  ctx.quadraticCurveTo(414 + x, 507 + y, 406 + x, 507 + y) //
  ctx.quadraticCurveTo(363 + x, 524 + y, 360 + x, 532 + y) // 左上
  ctx.quadraticCurveTo(362 + x, 533 + y, 367 + x, 532 + y) //
  ctx.quadraticCurveTo(398 + x, 520 + y, 398 + x, 520 + y) //
  ctx.quadraticCurveTo(391 + x, 528 + y, 393 + x, 536 + y) //
  ctx.quadraticCurveTo(376 + x, 539 + y, 350 + x, 538 + y) //
  ctx.quadraticCurveTo(343 + x, 541 + y, 347 + x, 547 + y) //
  ctx.quadraticCurveTo(353 + x, 565 + y, 373 + x, 575 + y) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

// ラベル上のくり抜き部分＿黒地埋め
const hollowOutOfYsrLabel = (ctx: CanvasRenderingContext2D, edgeColor: string, outOfEdgeColor: string, x: number, y: number) => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = edgeColor
  ctx.fillStyle = outOfEdgeColor
  ctx.beginPath()
  // 左1番目
  ctx.moveTo(369 + x, 560 + y) // 左下
  ctx.quadraticCurveTo(375 + x, 554 + y, 385 + x, 546 + y) // 右上
  ctx.quadraticCurveTo(369 + x, 546 + y, 361 + x, 551 + y) // 左上
  ctx.quadraticCurveTo(363 + x, 557 + y, 369 + x, 560 + y) // 左下
  // 左2番目
  ctx.moveTo(412 + x, 552 + y) // 左下
  ctx.quadraticCurveTo(421 + x, 547 + y, 421 + x, 547 + y) // 右下
  ctx.quadraticCurveTo(418 + x, 543 + y, 418 + x, 543 + y) // 右上
  ctx.quadraticCurveTo(410 + x, 544 + y, 406 + x, 545 + y) // 左上
  ctx.quadraticCurveTo(408 + x, 549 + y, 412 + x, 552 + y) // 左下
  // 左3番目
  ctx.moveTo(434 + x, 548 + y) // 左下
  ctx.quadraticCurveTo(442 + x, 540 + y, 442 + x, 540 + y) // 右上
  ctx.quadraticCurveTo(433 + x, 541 + y, 433 + x, 541 + y) // 左上
  ctx.quadraticCurveTo(434 + x, 547 + y, 434 + x, 548 + y) // 左下
  // 左4番目
  ctx.moveTo(454 + x, 541 + y) // 左
  ctx.quadraticCurveTo(465 + x, 540 + y, 472 + x, 534 + y) // 右
  ctx.quadraticCurveTo(459 + x, 536 + y, 454 + x, 541 + y) // 左

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

export const ysrLabel = (ctx: CanvasRenderingContext2D, value: string, x: number, y: number): void => {
  const colorObject = ysrLabelColorObjs.filter((object) => object.value === value)[0]
  labelBase(ctx, colorObject?.outOfEdge || '#eee', x, y)
  labelCore(ctx, colorObject?.edge || '#eee', colorObject?.core || '#eee', x, y)
  hollowOutOfYsrLabel(ctx, colorObject?.edge || '#eee', colorObject?.outOfEdge || '#eee', x, y)
}

export const ysrDirectLabel = (
  ctx: CanvasRenderingContext2D,
  mainColor: StateObj,
  edgeColor: StateObj,
  bandColor: StateObj,
  x: number,
  y: number
): void => {
  const border = edgeColor?.color || '#eee'
  const core = mainColor?.color || '#eee'
  const band = bandColor.color || '#eee'
  labelCore(ctx, border, core, x, y)
  hollowOutOfYsrLabel(ctx, border, band, x, y)
}

// 捕球面の刻印
export const ysrEngravedOfCatchFace = (ctx: CanvasRenderingContext2D, strokeColor: string): void => {
  ctx.lineWidth = 1.5
  ctx.strokeStyle = strokeColor
  ctx.beginPath()
  ctx.font = '22px serif'
  ctx.strokeText(`" Yell-story "`, 405, 430)
  ctx.font = '14px serif'
  ctx.strokeText(`since2017`, 440, 450)
  ctx.stroke()
  ctx.closePath()
}
